import { h } from 'preact';
import { useRef, useState } from 'preact/hooks';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Scrollbar } from 'swiper';
import './shop-the-look-dropdown.css';
import { IconRightArrow, IconArrowDown } from 'utils/icon';
import ProductCard from 'utils/product-card';
import WishlistContext from '../utils/gift-reggie/wishlist-context';

const ShopTheLookDropdown = (props) => {
  const {
    products,
    sectionId,
    mobileLayout,
    ctaButton,
    layout,
    ctaCopy,
    headLogic,
    showGallery,
    title,
  } = props;
  const [imageHeight, setImageHeight] = useState(400);
  const [showProductRecommendations, setShowProductRecommendations] =
    useState(showGallery);

  const toggleProductRecommendations = () => {
    setShowProductRecommendations((prev) => !prev);
  };

  return (
    <WishlistContext>
      <div className="text-center">
        <div className="flex justify-center items-center min-h-[44px] mb-5 lg:mb-10">
          {headLogic === 'btn' ? (
            <a
              className={`
              shop-the-look-dropdown__button 
              no-underline button button--primary min-h-[44px] min-w-[203px] 
              focus:outline-0 focus:outline-offset-0 focus:ring-offset-0 
              focus:ring-0 gap-2.5
              ${ctaButton !== 'black' ? ' button--tertiary ' : null}
              ${
                showProductRecommendations && ctaButton !== 'black'
                  ? ' bg-gray-200'
                  : showProductRecommendations && ctaButton === 'black'
                  ? ' bg-gray-800'
                  : ''
              }
            `}
              data-shop-the-look-dropdown-button
              onClick={toggleProductRecommendations}
            >
              {ctaCopy}
              <IconArrowDown
                direction={showProductRecommendations ? 'top' : 'bottom'}
                ctaButton={ctaButton}
              />
            </a>
          ) : (
            <h2 className={`h2 mb-5`}>{title}</h2>
          )}
        </div>
        {showProductRecommendations && products.length ? (
          <div>
            <ProductRecommendations
              productsLength={products.length}
              products={products}
              sectionId={sectionId}
              imageHeight={imageHeight}
              setImageHeight={setImageHeight}
              mobileLayout={mobileLayout}
              layout={layout}
            />
          </div>
        ) : null}
      </div>
    </WishlistContext>
  );
};

const ProductRecommendations = ({
  products,
  productsLength,
  sectionId,
  imageHeight,
  setImageHeight,
  mobileLayout,
  layout,
}) => {
  const swiper = useRef();
  const nextArrowClass = `.swiper-button-next-${sectionId}`;
  const prevArrowClass = `.swiper-button-prev-${sectionId}`;
  const isMobileLayoutGrid = mobileLayout === 'grid';

  const renderMobileGridLayout = () => (
    <div className="grid grid-cols-2 gap-1.5 gap-y-[30px] lg:gap-y-1.5">
      {products.slice(0, 6).map((product, index) => (
        <div key={`grid-item-${index}`}>
          <ProductCard product={product} />
        </div>
      ))}
    </div>
  );

  return (
    productsLength > 0 && (
      <div
        className={`text-center lg:!px-0 overflow-hidden ${
          productsLength ? '' : '!px-5'
        }`}
        data-shop-the-look-dropdown
        ref={swiper}
      >
        {isMobileLayoutGrid && !layout.isAboveBreakpoint('lg') ? (
          renderMobileGridLayout()
        ) : (
          <Swiper
            modules={[Navigation, Scrollbar]}
            observer={true}
            onObserverUpdate={() => {
              const productImageHeight =
                swiper.current.querySelector('.product-card img')?.offsetHeight;
              if (productImageHeight) setImageHeight(productImageHeight);
            }}
            navigation={{
              nextEl: nextArrowClass,
              prevEl: prevArrowClass,
              disabledClass: '!opacity-0',
            }}
            slidesPerView={productsLength ? 2 : 1.8}
            spaceBetween={6}
            scrollbar={{
              el: '.swiper-scrollbar',
              draggable: true,
            }}
            breakpoints={{
              1024: {
                slidesPerView: 4,
              },
            }}
            className="relative w-full product-recommendations"
          >
            <div
              className={`${`swiper-button-prev-${sectionId}`} 
              swiper-button-prev cursor-pointer absolute 
              hidden lg:flex h-[42px] w-[42px]
              rotate-180 items-center justify-center
              bg-white drop-shadow-md rounded-full origin-center 
              transition-opacity -translate-y-1/2 left-14 z-1`}
              style={{ top: imageHeight / 2 }}
            >
              <IconRightArrow />
            </div>
            <div
              className={`${`swiper-button-next-${sectionId}`} 
              swiper-button-next cursor-pointer 
              absolute hidden lg:flex h-[42px] w-[42px] 
              items-center justify-center rounded-full 
              bg-white drop-shadow-md transition-opacity 
              -translate-y-1/2 right-14 z-1`}
              style={{ top: imageHeight / 2 }}
            >
              <IconRightArrow />
            </div>
            {products.map((product, index) => (
              <SwiperSlide
                key={`${product.id} + ${index}}`}
                className="md:w-[335px] w-[184px] pb-[5px]"
              >
                <ProductCard product={product} />
              </SwiperSlide>
            ))}
            <div
              className={`swiper-scrollbar lg:!hidden !h-0.5 
              !relative mt-7 lg:mt-10 !inset-auto ${
                productsLength ? '!w-[calc(100%-40px)] !mx-auto' : ''
              }`}
            ></div>
          </Swiper>
        )}
      </div>
    )
  );
};

export default ShopTheLookDropdown;
